import React from "react";
import { BlueBirdTheme, Button, Typography } from "@kitbird/core";
import { useUserPosition } from "../Provider";
import Modal from "../../../../components/Modal";

const DeleteModal = () => {
  const {
    modal,
    setModal,
    selectedRow,
    setSelectedRow,
    handleDeleteUser,
    loadingDelete,
  } = useUserPosition();

  const handleCloseModal = () => {
    setModal("");
    setSelectedRow(undefined);
  };

  return (
    <Modal
      title="Konfirmasi hapus data"
      isOpen={modal === "DELETE"}
      setOpen={() => handleCloseModal()}
      body={
        <Typography level={5} fontWeight="medium">
          Apakah Anda yakin ingin menghapus data
          <Typography level={5} fontWeight="bold">
            &nbsp;{selectedRow?.employee_name} - {selectedRow?.employee_id}&nbsp;
          </Typography>
          dari master user?
        </Typography>
      }
      footer={
        <>
          <Button
            variant="text"
            onClick={() => handleCloseModal()}
          >
            Batal
          </Button>
          <Button
            backgroundColor={loadingDelete ? undefined : BlueBirdTheme.colors.danger[500]}
            onClick={() => handleDeleteUser()}
            disabled={loadingDelete}
          >
            {loadingDelete ? "Loading,,, " : "Ya, hapus"}
          </Button>
        </>
      }
    />
  );
};

export default DeleteModal;
